'use strict';

;( function() {

	document.addEventListener( 'DOMContentLoaded', function() {

		var gridCells = Array.from( document.querySelectorAll( '[data-grid-lazy]' ) );
		if ( ! gridCells.length ) return;

		var gridWrapper = document.getElementById( 'stat-grid-wrapper' );
		if ( ! gridWrapper ) return;

		var rows = [];
		var ALL_CLASSES = ['row-idle', 'row-active', 'row-prev-1', 'row-prev-2', 'row-prev-3', 'row-future'];

		function buildRows() {
			var rowMap = {};

			gridCells.forEach( function( cell ) {
				var top    = Math.round( cell.getBoundingClientRect().top - gridWrapper.getBoundingClientRect().top );
				var rowKey = Math.round( top / 5 ) * 5;

				if ( ! rowMap[rowKey] ) {
					rowMap[rowKey] = [];
				}
				rowMap[rowKey].push( cell );
			});

			var sortedKeys = Object.keys( rowMap ).map( Number ).sort( function( a, b ) {
				return a - b;
			});

			rows = sortedKeys.map( function( key ) {
				return rowMap[key];
			});
		}

		buildRows();

		var resizeTimeout;
		window.addEventListener( 'resize', function() {
			clearTimeout( resizeTimeout );
			resizeTimeout = setTimeout( function() {
				buildRows();
				handleScroll();
			}, 150 );
		});

		function setRowClass( rowCells, className ) {
			rowCells.forEach( function( cell ) {
				ALL_CLASSES.forEach( function( cls ) {
					cell.classList.remove( cls );
				});
				cell.classList.add( className );
			});
		}

		var lastActiveRow = -2;

		function handleScroll() {
			if ( !rows.length ) return;

			var wrapperRect = gridWrapper.getBoundingClientRect();
			var windowH     = window.innerHeight;

			var progress = ( windowH - wrapperRect.top ) / ( windowH + wrapperRect.height );
			progress = Math.max( 0, Math.min( 1, progress ) );

			var totalRows = rows.length;
			var activeRow = -1;

			if ( 0.08 < progress ) {
				var scaled = ( progress - 0.08 ) / 0.77;
				scaled    = Math.max( 0, Math.min( 1, scaled ) );
				activeRow = Math.floor( scaled * totalRows );
				if ( activeRow >= totalRows ) activeRow = totalRows - 1;
			}

			if ( activeRow === lastActiveRow ) return;
			lastActiveRow = activeRow;

			rows.forEach( function( rowCells, i ) {
				if ( -1 === activeRow ) {
					setRowClass( rowCells, 'row-idle' );
				} else if ( i === activeRow ) {
					setRowClass( rowCells, 'row-active' );
				} else if ( i === activeRow - 1 ) {
					setRowClass( rowCells, 'row-prev-1' );
				} else if ( i === activeRow - 2 ) {
					setRowClass( rowCells, 'row-prev-2' );
				} else if ( i < activeRow - 2 ) {
					setRowClass( rowCells, 'row-prev-3' );
				} else {
					setRowClass( rowCells, 'row-future' );
				}
			});
		}

		var ticking = false;
		window.addEventListener( 'scroll', function() {
			if ( !ticking ) {
				window.requestAnimationFrame( function() {
					handleScroll();
					ticking = false;
				});
				ticking = true;
			}
		}, { passive: true });

		handleScroll();

	});
})();
